export default __webpack_public_path__ + "static/betterworldbooks-36cb805747e589f240693d41394de70a.png";